
export const host = '' 

export const childWebsite = process.env.NODE_ENV != 'production' ? 'http://ke.xhce.cn' : window.location.host //'http://ke.xhce.cn'//'www.xhit.com:9595'//'http://www.hxzyzx.net'//http://ke.nxxdf.com'http://ke.zjomick.com' 'http://ke.xhce.cn' //'http://zhdkxk.natappfree.cc' ''

export const staticHost = 'https://xiaochengxu.xhe.cn/xhyktimg'//'http://kestatic.xhe.cn'

export let payVipUrl = `${host}/to/alipay`

export const sellType = {
	'COURSE': 'course',
	'COURSECHAPTERS': 'mulcourse',
	'PACKAGE':'package'
}

export const windowWidth = document.documentElement.clientWidth
export const windowHeight =document.documentElement.clientHeight// window.screen.availHeight//



// WEBPACK FOOTER //
// ./src/common/js/config.js